import React, { useContext } from "react";
import { Layout, LoginLayout } from "@app/components";
import { AuthContext } from "@app/providers";
import { BoyPage, GirlPage } from "@app/assets";

export default function PageNotFound() {
  const { userInfo } = useContext(AuthContext);
  if (userInfo && userInfo.sessionToken) {
    return (
      <Layout
        className="flexed aligned-center"
        classname="custom-message centered h-300"
      >
        <h3 className="primary-header">Page Not Found</h3>
        <img alt="" className="page-left-aligned-image" src={BoyPage} />
        <img alt="" className="page-right-aligned-image" src={GirlPage} />
      </Layout>
    );
  } else {
    return (
      <LoginLayout path="" label="" classname="h-300">
        <h3 className="primary-header">Page Not Found</h3>
        <img alt="" className="left-aligned-image" src={BoyPage} />
        <img alt="" className="right-aligned-image" src={GirlPage} />
      </LoginLayout>
    );
  }
}
